<section class="devices-section">

    <div class="container-redesign">

        <div class="devices-section__wrapper">

            <div class="devices-section__content">

                <h2 class="devices-section__title">
                    Medical grade
                    <span>healthcare devices</span>
                </h2>

                <p class="devices-section__description">
                    Connect AltheaCare to leading wearables and monitoring devices to enable
                    real-time tracking, vital signs monitoring, and secure data flow—
                    cloud or on-premises.
                </p>

                <div class="devices-section__list">

                    <div
                        class="devices-section__item"
                        *ngFor="let feature of features; trackBy: trackByText">

                        <span>{{ feature.text }}</span>

                        <img
                            src="/assets/img/redesign/flecha.svg"
                            alt="">

                    </div>

                </div>

            </div>

            <div class="devices-section__image">

                <img
                    src="/assets/img/redesign/devices04.jpg"
                    alt="Healthcare devices">

            </div>

        </div>

    </div>

</section>